/* Aza Natural — eigen scripts (thema-scoped) */

/* USP-blok op de productpagina als naadloze horizontale marquee.
   De items worden 1x gedupliceerd zodat de CSS-animatie naadloos kan loopen. */
(function () {
  function initUspMarquee() {
    var lists = document.querySelectorAll('.uspblock .-icon-list-items');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.getAttribute('data-marquee')) continue;
      if (!list.children.length) continue;
      list.setAttribute('data-marquee', '1');
      var items = Array.prototype.slice.call(list.children);
      for (var j = 0; j < items.length; j++) {
        var clone = items[j].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        list.appendChild(clone);
      }
    }
  }
  if (document.readyState !== 'loading') {
    initUspMarquee();
  } else {
    document.addEventListener('DOMContentLoaded', initUspMarquee);
  }
})();

/* Gratis-verzendbalk: bouwt de melding om tot een bezorgbalk met
   vrachtwagen-icoon en een voortgangsbalk. Het thema levert alleen de
   kale tekst; hier maken we er een zichtbare voortgang van.
   Werkt ook nadat de winkelwagen opnieuw is opgebouwd. */
(function () {
  var TRUCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="1" y="4" width="14" height="11" rx="1.5"/>' +
    '<path d="M15 8h4l3.5 3.5V15H15z"/>' +
    '<circle cx="5.5" cy="18" r="2.4"/><circle cx="18" cy="18" r="2.4"/></svg>';

  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function build(el, attempt) {
    if (!el || el.getAttribute('data-aza-ship')) return;

    var message = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!message) {
      // Het thema heeft de tekst nog niet gezet -> kort opnieuw proberen.
      if ((attempt || 0) < 20) {
        setTimeout(function () { build(el, (attempt || 0) + 1); }, 100);
      }
      return;
    }

    var threshold = Number(el.getAttribute('data-free-shipping'));
    var total = Number(el.getAttribute('data-cart-total-amount'));
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      rate = Number(Shopify.currency.rate) || 1;
    }
    var goal = Math.round(threshold * rate);
    var pct = goal > 0 ? Math.max(0, Math.min(100, (total / goal) * 100)) : 100;
    var done = pct >= 100;

    // Het resterende bedrag in de tekst extra laten opvallen.
    var html = escapeHtml(message);
    var amount = html.match(/(?:€|EUR)\s?[\d.,]+|[\d.,]+\s?(?:€|EUR)/);
    if (amount) {
      html = html.replace(amount[0], '<strong>' + amount[0] + '</strong>');
    }

    el.setAttribute('data-aza-ship', '1');
    el.innerHTML =
      '<div class="aza-ship' + (done ? ' is-complete' : '') + '">' +
        '<span class="aza-ship__icon">' + TRUCK + '</span>' +
        '<div class="aza-ship__body">' +
          '<p class="aza-ship__msg">' + html + '</p>' +
          '<span class="aza-ship__track">' +
            '<span class="aza-ship__fill"></span>' +
          '</span>' +
        '</div>' +
      '</div>';

    // Breedte pas daarna zetten, zodat de balk zichtbaar naar rechts loopt.
    var fill = el.querySelector('.aza-ship__fill');
    if (fill) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { fill.style.width = pct.toFixed(1) + '%'; });
      });
    }
  }

  function scan() {
    var nodes = document.querySelectorAll('shipping-notice');
    for (var i = 0; i < nodes.length; i++) build(nodes[i], 0);
  }

  function init() {
    scan();
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      var notices = new Set();
      records.forEach(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        var notice = target && target.closest('shipping-notice');
        if (notice && !notice.hasAttribute('data-aza-ship')) notices.add(notice);
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('shipping-notice')) notices.add(node);
          node.querySelectorAll('shipping-notice').forEach(function (el) { notices.add(el); });
        });
      });
      notices.forEach(function (el) { build(el, 0); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* Kortingscode in de exit-intent pop-up kopieren met een klik. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-aza-copy]') : null;
    if (!button) return;

    var code = button.getAttribute('data-aza-copy');
    var hint = button.querySelector('.exit-intent__code-hint');

    function done() {
      button.classList.add('is-copied');
      if (hint) hint.textContent = 'Gekopieerd';
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
      return;
    }
    // Terugvaloptie voor oudere browsers
    var helper = document.createElement('textarea');
    helper.value = code;
    helper.setAttribute('readonly', '');
    helper.style.position = 'absolute';
    helper.style.left = '-9999px';
    document.body.appendChild(helper);
    helper.select();
    try { document.execCommand('copy'); done(); } catch (e) {}
    document.body.removeChild(helper);
  });
})();

/* Leverbelofte op de productpagina: berekent de eerstvolgende verzenddag
   in de tijdzone van de winkel en telt af tot het uiterste besteltijdstip.
   Rekent dus niet met de klok van de bezoeker, die kan in een ander land staan. */
(function () {
  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MAANDEN = ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
                 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function offsetToMs(value) {
    var m = /^([+-])(\d{2})(\d{2})$/.exec((value || '').trim());
    if (!m) return null;
    return (m[1] === '-' ? -1 : 1) * ((Number(m[2]) * 60) + Number(m[3])) * 60000;
  }

  function update(el) {
    var offset = offsetToMs(el.getAttribute('data-offset'));
    if (offset === null) return;

    var cutoff = Number(el.getAttribute('data-cutoff'));
    var saturday = el.getAttribute('data-saturday') === '1';
    var shop = new Date(Date.now() + offset);   // UTC-getters geven nu de winkeltijd

    var hour = shop.getUTCHours();
    var inTime = hour < cutoff;

    var ship = new Date(shop.getTime() + (inTime ? 86400000 : 172800000));
    for (var i = 0; i < 3; i++) {
      var day = ship.getUTCDay();
      if (day === 0 || (day === 6 && !saturday)) {
        ship = new Date(ship.getTime() + 86400000);
      }
    }

    var label = DAGEN[ship.getUTCDay()] + ' ' + ship.getUTCDate() + ' ' + MAANDEN[ship.getUTCMonth()];
    var dayEl = el.querySelector('[data-aza-delivery-day]');
    if (dayEl) dayEl.textContent = label;

    var countdown = el.querySelector('[data-aza-delivery-countdown]');
    if (!countdown) return;

    if (!inTime) { countdown.hidden = true; return; }

    var left = (cutoff * 3600) - (hour * 3600 + shop.getUTCMinutes() * 60 + shop.getUTCSeconds());
    if (left <= 0) { countdown.hidden = true; return; }

    var hours = Math.floor(left / 3600);
    var minutes = Math.floor((left % 3600) / 60);
    var text = hours > 0 ? hours + ' uur en ' + minutes + ' min' : minutes + ' min';
    countdown.textContent = 'Nog ' + text + ' om vandaag te bestellen.';
    countdown.hidden = false;
  }

  function run() {
    var nodes = document.querySelectorAll('[data-aza-delivery]');
    for (var i = 0; i < nodes.length; i++) update(nodes[i]);
  }

  if (document.readyState !== 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }
  setInterval(run, 30000);
})();
